<template>
  <v-dialog v-model="show"
            :transition="false"
            width="425"
  >
    <v-sheet class="service-prepare-dialog__contents">
      <v-toolbar height="80">
        <v-btn icon width="80" height="80"
               disabled
        />

        <v-toolbar-title>알림</v-toolbar-title>

        <v-btn icon
               width="80"
               height="80"
               @click="show = false"
        >
          <v-icon size="50">
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="service-prepare-dialog__description">
        서비스 준비중입니다.
      </v-card-text>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  name: 'ServicePrepareDialog',
  props: {
    value: { type: Boolean, default: false },
  },
  computed: {
    show: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped>

</style>